import { Link } from 'react-router';
import { BrandMark, buttonVariants } from '@/components/ui';

export default function NotFound() {
  return (
    <div className="grid min-h-dvh place-items-center bg-canvas px-6 text-center">
      <div className="max-w-md">
        <BrandMark className="mx-auto size-20" />
        <p className="mt-6 font-heading text-6xl font-semibold text-ink">404</p>
        <h1 className="mt-2 font-heading text-2xl font-semibold text-ink">We could not find that page</h1>
        <p className="mt-2 text-ink-muted">The link may be broken, or the page may have moved.</p>
        <Link to="/" className={buttonVariants({ size: 'lg', className: 'mt-6' })}>
          Back to MedicAiL
        </Link>
      </div>
    </div>
  );
}
